import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { GUEST_INBOX_V2_EMAILS } from '@new/__global/constants/emailsList'

import { getLocalStorageItem } from '@utils/localStorage'

import { BackofficeRouterSelection, selectBackofficeRouter } from './backofficeRouterSelection'

const selectFor = (email: string | null) =>
  selectBackofficeRouter({
    mode: import.meta.env.MODE,
    hiveUrl: import.meta.env.VITE_ARRIERE_BACKOFFICE_HIVE_URL,
    optIn: getLocalStorageItem('voyage:hive-router'),
    isBetaTester: !!email && GUEST_INBOX_V2_EMAILS.includes(email),
  })

// Updated in place, so fetchApi and partial-response reports always read the current router.
export const backofficeRouter: BackofficeRouterSelection = selectFor(null)

if (backofficeRouter.url) arriereBackoffice.setUrl(backofficeRouter.url)

// Production picks Hive only for beta testers, so the choice waits for the signed-in email.
// Signing out (email null) returns to the startup choice.
export const selectBackofficeRouterForUser = (email: string | null) => {
  const next = selectFor(email)

  if (next.router === backofficeRouter.router) return

  backofficeRouter.router = next.router
  backofficeRouter.url = next.url
  arriereBackoffice.setUrl(next.url ?? (process.env.REACT_APP_ARRIERE_BACKOFFICE as string))
}
